<template>

    <Head>
        <title>Desarrollo integral de la familia</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url('/img/hero-dif.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Desarrollo integral<br/> de la familia</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general bloque-info-img">
            <div class="container">
                <div class="row flex-md-row-reverse">
                    <div class="col-md-7">
                        <h2 class="bloque-subencabezado">Somos una Institución reconocida por brindar atención cercana a
                            las familias Santiaguenses y grupos vulnerables.</h2>
                        <div class="bloque-descripcion">
                            <p>Nuestro objetivo es procurar el bienestar familiar a través de la promoción y prestación
                                de servicios de asistencia social y protección de derechos de los habitantes del
                                Municipio, mediante acciones que mejoren el entorno social y favorezcan el desarrollo
                                integral del individuo. También protegemos la salud física, mental y social de personas
                                en estado de vulnerabilidad, hasta lograr su inclusión a una vida plena y productiva</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="bloque-info-img__img">
                            <img loading="lazy" width="278" height="245" src="/img/hexa-dif-centros.jpg" alt="DIF">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Conoce los diferentes trámites y servicios que ofrece el DIF municipal de Santiago-->
        <div class="bloque-general bloque-tarjetas-dif">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="bloque-encabezado">Conoce los diferentes servicios, cursos y actividades de los
                            Centros DIF</h2>
                    </div>

                    <div class="col-md-6 col-lg-6">
                        <div class="bloque-filtro">
                            <div class="bloque-filtro__encabezado">Filtrar por nombre o dirección</div>
                            <form action="#">
                                <div class="form-group">
                                    <input class="input-buscador" v-model="search" type="text" placeholder="">
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <div class="bloque-filtro">
                            <div class="bloque-filtro__encabezado">Filtrar por clase, servicio o actividad</div>
                            <form action="#">
                                <div class="form-group">
                                    <select v-model="curso" class="form-control form__select">
                                        <option value="">Todos</option>
                                        <option v-for="(item, index) in actividades" :key="index" :value="item.nombre">
                                            {{ item.nombre }}</option>
                                    </select>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="tarjeta-dif" v-for="(item, index) in filterCentros" :key="index">
                            <div class="row">
                                <div class="col-md-12 col-lg-5"><img :src="item.portada.medium+'?v=1.1'"></div>
                                <div class="col-md-12 col-lg-7 tarjeta-dif__info pb-0">
                                    <div class="tarjeta-dif__encabezado">{{ item.nombre }}</div>
                                    <div class="tarjeta-dif__direccion">
                                        <span><i class="fi fi-map-marker-alt"></i> Dirección</span>
                                        <p>{{ item.direccion }}</p>
                                    </div>
                                    <div class="tarjeta-dif__horarios">
                                        <div class="tarjeta-dif__horario">
                                            <i class="fi fi-clock"></i>
                                            <span>{{ item.horario }}</span>
                                        </div>
                                    </div>
                                    <div class="tarjeta-dif__horarios">
                                        <div class="tarjeta-dif__horario"><i class="fi fi-phone"></i> {{ item.telefono
                                        }}
                                        </div>
                                        <div class="tarjeta-dif__telefono ml-lg-2" v-if="item.email != ''"><i
                                                class="fi fi-email"></i> {{ item.email }}</div>
                                        <div class="tarjeta-dif__telefono ml-lg-2 contenido-administrable"
                                            v-if="item.link_mapa != ''"><i class="fi fi-map"></i> <a
                                                :href="item.link_mapa" target="_blank">Ver ubicación</a></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="tarjeta-dif__actividades p-4">
                                        <span class="actividades-encabezado">Actividades</span>
                                        <ul>

                                            <li v-for="(actividad, i) in item.actividades" :key="i">
                                                <div class="actividad-icono">
                                                    <img loading="lazy" width="17" height="20"
                                                        :src="'/storage/' + actividad.icono" alt="">
                                                </div>
                                                <span>{{ actividad.nombre }}</span>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div v-if="false" class="tarjeta-dif__img"
                                :style="`background-image: url('` + item.portada.medium + `');`">
                            </div>
                            <div v-if="false"  class="tarjeta-dif__info">
                                <div class="tarjeta-dif__encabezado">{{ item.nombre }}</div>
                                <div class="tarjeta-dif__direccion">
                                    <span><i class="fi fi-map-marker-alt"></i> Dirección</span>
                                    <p>{{ item.direccion }}</p>
                                </div>
                                <div class="tarjeta-dif__horarios">
                                    <div class="tarjeta-dif__horario">
                                        <i class="fi fi-clock"></i>
                                        <span>{{ item.horario }}</span>
                                    </div>
                                </div>
                                <div class="tarjeta-dif__horarios">
                                    <div class="tarjeta-dif__horario"><i class="fi fi-phone"></i> {{ item.telefono }}
                                    </div>
                                    <div class="tarjeta-dif__telefono ml-lg-2" v-if="item.email != ''"><i
                                            class="fi fi-email"></i> {{ item.email }}</div>
                                    <div class="tarjeta-dif__telefono ml-lg-2 contenido-administrable"
                                        v-if="item.link_mapa != ''"><i class="fi fi-map"></i> <a :href="item.link_mapa"
                                            target="_blank">Ver ubicación</a></div>
                                </div>
                                <div class="tarjeta-dif__actividades info">
                                    {{ item.informacion }}
                                </div>
                                <div class="tarjeta-dif__actividades">
                                    <span class="actividades-encabezado">Actividades</span>
                                    <ul>

                                        <li v-for="(actividad, i) in item.actividades" :key="i">
                                            <div class="actividad-icono">
                                                <img loading="lazy" width="17" height="20"
                                                    :src="'/storage/' + actividad.icono" alt="">
                                            </div>
                                            <span>{{ actividad.nombre }}</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="filterCentros.length < 1">
                            <NoResults />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    data() {
        return {
            search: '',
            curso: ''
        }
    },
    components: {
        NoResults, Link
    },
    props: {
        centros: Object,
        actividades: Object,
    },
    computed: {
        filterCentros: function () {
            return this.filterCentrosByName(
                this.filterCentrosByCurso(this.centros)
            )
        },
    },
    methods: {
        filterCentrosByName: function (centros) {
            return this.search
                ? centros.filter(
                    (item) => item.nombre.toLowerCase().includes(this.search.toLowerCase()) || item.direccion.toLowerCase().includes(this.search.toLowerCase())
                )
                : centros;
        },
        filterCentrosByCurso: function (centros) {
            return this.curso
                ? centros.filter(
                    item => item.actividades.find(
                        actividad => actividad.nombre.toLowerCase() == this.curso.toLowerCase()
                    )
                )
                : centros;
        },
    },
}
</script>
<style scoped>
.tarjeta-dif {
    display: flex;
    flex-direction: column;
}

.tramite-servicio-item {
    margin-right: 0 !important;
    margin-bottom: 30px;
}

.fi {
    margin-right: 5px;
    color: #b1b3db;
}

.tarjeta-dif__telefono {
    display: flex;
    align-items: center;
}

.tarjeta-dif__actividades.info {
    font-size: 1rem;
}
.tarjeta-dif__info {
    padding: 27px 30px 27px;
}
@media (min-width: 768px) {
    .tarjeta-dif__actividades ul {
        -moz-column-count: 3;
        column-count: 3;
    }
}

@media (min-width: 992px) {
    .tarjeta-dif__actividades ul {
        -moz-column-count: 4;
        column-count: 4;
    }
}

@media (min-width: 1200px) {
    .tarjeta-dif__actividades ul {
        -moz-column-count: 5;
        column-count: 5;
    }
}
</style>
